<template>
    <div class="status-mapping-select-container">
        <input
            type="checkbox"
            :checked="fieldEnabled"
            @input="updateValue"
            class="status-mapping-select"
        >
    </div>
</template>
<script setup lang="ts">
import { ICellRendererParams } from '@ag-grid-community/core';
import { defineProps, ref } from 'vue';

const props = defineProps<{
    params: ICellRendererParams;
}>();
const key = props.params.column.colId;
const fieldEnabled = ref<boolean>(props.params.data[key]);
async function updateValue(event: Event) {
    const target = <HTMLInputElement>event.target;
    const selectedNode = props.params.node;
    if (selectedNode.data) {
        selectedNode.data[key] = target.checked;
    }
}
</script>
<style lang="scss">
.status-mapping-select-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}
.status-mapping-select {
    height: 50%;
    width: 50%;
    accent-color: #0d875e;
}
</style>
